import { css } from 'lit-element';
/* @internal */
export const styles = css`cds-search input[type='search']::-webkit-search-cancel-button{display:none}
`;
